import ComponentWithSocket from '../../../lib/component';
import { Component } from 'vue-property-decorator';

@Component
export default class BlogList extends ComponentWithSocket {
    private readonly token = 'c8f02a40c3fa8e6383228cc95242aac3';

    public articles: any[] = [];
    public currentPage: number = 1;
    public lastPage: number = 1;
    public total: number = 0;
    public perPage: number = 20;

    constructor() {
        super();
    }

    mounted() {
        this.getArticles();
    }

    async getArticles(page: number = 1) {
        const url = `${process.env.API2_URL}/admin/article?token=${this.token}&page=${page}&limit=${this.perPage}`;

        await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
            }

            return response.json();
        }).then(data => {
            if (data && data.success) {
                this.articles = data.data;
                this.currentPage = data.meta.current_page;
                this.lastPage = data.meta.last_page;
                this.total = data.meta.total;
                this.perPage = data.meta.per_page;
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    }

    async removeArticle(id: string) {
        if (!confirm('Sigur stergi articolul?')) {
            return;
        }

        await fetch(`${process.env.API2_URL}/article/${id}?token=${this.token}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
            }

            return response.json();
        }).then(data => {
            if (data && data.success) {
                this.getArticles(this.currentPage);
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/blog/list/index.ts